import FallbackPage from "../Pages/FallBackPage/FallBackPage";
import Login from "../Pages/Login/Login";
import Gallery from "../Pages/Gallery/Gallery";
import Accepted from "../Pages/Accepted.jsx";
import ImageView from "../Pages/ImageView/ImageView.jsx";
import ImageViewAccepted from "../Pages/ImageViewAccepted/ImageViewAccepted.jsx";
import { useSelector } from "react-redux";
import {
  Route,
  BrowserRouter as Router,
  Routes,
  useLocation,
} from "react-router-dom";
import NavBar from "../Components/Navbar/navbar.js";

function Paths() {
  const user = useSelector((state) => state.user);
  const location = useLocation();

  // Determine if the NavBar should be displayed
  const showNavBar =
    location.pathname !== "/ImageView" &&
    location.pathname !== "/AcceptedImageView";

  return (
    <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
      <main
        className="content"
        style={{ flex: 1, padding: "16px", overflow: "auto" }}
      >
        <Routes>
          {user.isLogged ? (
            <>
              <Route path="/" element={<Gallery />} />
              <Route path="/ImageView" element={<ImageView />} />
              <Route path="/Accepted" element={<Accepted />} />
              <Route
                path="/AcceptedImageView"
                element={<ImageViewAccepted />}
              />
            </>
          ) : (
            <>
              <Route path="/" element={<Login />} />
              <Route path="/ImageView" element={<Login />} />
              <Route path="/Accepted" element={<Login />} />
              <Route path="/AcceptedImageView" element={<Login />} />
              <Route path="*" element={<FallbackPage />} />
            </>
          )}
        </Routes>
      </main>
      {showNavBar && user.isLogged && <NavBar />}
    </div>
  );
}

export default function AppPaths() {
  return (
    <Router>
      <Paths />
    </Router>
  );
}
